module.exports = __webpack_public_path__ + "img/icon_uploadPhoto.a425e919.svg";